export default "__VITE_ASSET__DlQPRa9f__"